/**
 * Loading placeholder for the professional's slot list. Mirrors the real
 * list's card shell + a few rows so the owner sees a stable "loading" state
 * instead of the empty "create your first slot" box flashing before the
 * slots resolve.
 */
export function SlotsListSkeleton({ rows = 3 }: { rows?: number }) {
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4" aria-hidden="true">
      <div className="mb-4 h-5 w-32 animate-pulse rounded bg-gray-200" />
      <div className="space-y-3">
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className="flex items-center gap-3 rounded-md border border-gray-100 p-3">
            <div className="h-10 w-1 flex-shrink-0 animate-pulse rounded bg-gray-200" />
            <div className="min-w-0 flex-1 space-y-2">
              <div className="h-4 w-2/3 animate-pulse rounded bg-gray-200" />
              <div className="h-3 w-1/3 animate-pulse rounded bg-gray-200" />
            </div>
            <div className="h-4 w-12 flex-shrink-0 animate-pulse rounded bg-gray-200" />
          </div>
        ))}
      </div>
    </div>
  );
}
